/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
import {Trans} from '@lingui/macro';
import {Grid, TextField, Button, CardMedia} from '@material-ui/core';
import {PermMedia} from '@material-ui/icons';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import React, {useState, useEffect} from 'react';
import {useDropzone} from 'react-dropzone';
import MediaDisplayer from './../../capacitation/component/MediaDisplayer';

function AddPDF(props) {
  const {
    setFieldValue,
    pdfName,
    extension,
    urlMedia,
    fieldName = 'name',
    maxFileSizeBytes = 100 * 1024 * 1024,
  } = props;
  const [name, setName] = useState(pdfName);
  const [url, setUrl] = useState('');
  const [type, setType] = useState('video');
  const [isEditing, setIsEditing] = useState(props.isEditing);
  const [fileError, setFileError] = useState('');
  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    accept: extension === 'PDF' ? '.pdf' : 'video/*, audio/*',
    multiple: false,
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (!file) {
        return;
      }

      if (file.size > maxFileSizeBytes) {
        setFileError(
          i18n2._('El archivo supera el tamano maximo permitido.') +
            ` (${Math.round(maxFileSizeBytes / (1024 * 1024))} MB)`,
        );
        setFieldValue('files', []);
        return;
      }

      setFileError('');
      setName(file.name.replace(/\.[^/.]+$/, ''));
      setUrl(URL.createObjectURL(file));
      setType(file.type.split('/')[0]);
      setFieldValue('files', [file]);
    },
  });

  useEffect(() => {
    setFieldValue(fieldName, name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  const filesjsx = acceptedFiles.map((file) => (
    <>
      <Field
        name={fieldName}
        required
        component={TextField}
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        label={i18n2._('Nombre del archivo.')}
        autoFocus
        fullWidth
        variant="outlined"
      />
    </>
  ));

  if (isEditing) {
    return (
      <>
        <Grid item xs={12}>
          <Field
            name={fieldName}
            required
            component={TextField}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            label={i18n2._('Nombre del archivo.')}
            autoFocus
            fullWidth
            variant="outlined"
          />
        </Grid>
        {extension !== 'PDF' && (
          <Grid item xs={12}>
            <MediaDisplayer file={urlMedia} route={''} />
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setIsEditing(false)}>
            <Trans>Cargar nuevo archivo.</Trans>
          </Button>
        </Grid>
      </>
    );
  } else {
    return (
      <>
        <div {...getRootProps({className: 'dropzone'})}>
          <input {...getInputProps()} />
          {filesjsx.length > 0 ? (
            <>
              {acceptedFiles.map((file) => (
                <>
                  {extension === 'PDF' ? (
                    <PictureAsPdf style={{fontSize: 40}} />
                  ) : (
                    <PermMedia style={{fontSize: 40}} />
                  )}
                  <li style={{listStyleType: 'none'}} key={file.path}>
                    {file.path} - {file.size} bytes
                  </li>
                </>
              ))}
            </>
          ) : (
            <Trans>
              Arrastre el archivo aquí o haga click para seleccionarlo.
            </Trans>
          )}
        </div>
        <Grid item xs={12} style={{paddingTop: 10}}>
          {filesjsx}
        </Grid>
        {fileError && (
          <Grid item xs={12}>
            <span style={{color: '#d32f2f'}}>{fileError}</span>
          </Grid>
        )}
      </>
    );
  }
}

export default AddPDF;
